import {safeFetch} from "./App";

export const memoryCache = {};

export async function cacheSafeFetch(url, chatId, options = {}, config = {}) {
    const { cacheKey = null, forceRefresh = false } = config;

    // Check memory cache
    if (cacheKey && memoryCache[cacheKey] && !forceRefresh) {
        return {
            ok: true,
            json: async () => memoryCache[cacheKey].data,
        };
    }
    const headers = {
        ...(options.headers || {}),
    };

    // DEBUG: Only attach x-chat-id on POST/PUT or if explicitly needed
    if (options.method !== 'GET' && chatId) {
        headers['x-chat-id'] = chatId;
    }

    const res = await safeFetch(url, chatId,{
        ...options,
            headers
    });

    if (res.ok && cacheKey) {
        const jsonData = await res.clone().json(); // clone for reuse
        memoryCache[cacheKey] = {
            data: jsonData,
            expiresAt: Date.now() + 10 * 60 * 1000,
        };

        return {
            ok: true,
            json: async () => jsonData,
        };
    }

    return res;
}
